import * as React from "react";
import { Card } from "antd";
import { CardContent } from "../../components/antd/card/CardContent";
import { homeLink, linksOf, request } from "../../services/cpln";
import { Agent } from "../../schema/types/agent/entity";
import { Identity } from "../../schema/types/identity/entity";
import { LastModifiedColumn } from "../../newcomponents/table/columns/wellKnown/lastModifiedColumn";
import { CreatedColumn } from "../../newcomponents/table/columns/wellKnown/createdColumn";
import { TagsColumn } from "../../newcomponents/table/columns/wellKnown/tagsColumn";
import { WorkloadGvcColumn } from "../../newcomponents/table/columns/workload/gvcColumn";
import { NameDescriptionColumn } from "../../newcomponents/table/columns/wellKnown/nameDescriptionColumn";
import { Table } from "../../newcomponents/table/table";
import { IdentityTableItem } from "../../mst/kinds/identity.helpers";

interface Props {
  agent: Agent;
}
export const UsedInIdentities: React.FC<Props> = ({ agent }) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [identities, setIdentities] = React.useState<Identity[]>([]);

  React.useEffect(() => {
    fetchIdentities();
  }, []);

  async function fetchIdentities() {
    try {
      setIsLoading(true);
      setIdentities([]);
      let _identities: Identity[] = [];
      let link = homeLink("identity");
      while (link) {
        const { data } = await request({ url: link });
        link = data.links.find((l: any) => l.rel === "next")?.href;
        _identities = _identities.concat(data.items);
      }
      setIdentities(_identities);
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
    }
  }

  const usedIdentities: IdentityTableItem[] = identities
    .map((identity) => {
      const selfLink = linksOf(identity).self!;
      const gvc = selfLink.split("/")[4];
      return { ...identity, selfLink, gvc };
    })
    .filter((identity) => identity.networkResources?.some((nr) => nr.agentLink === linksOf(agent).self!));

  return (
    <>
      <div className="cpln-form-section cpln-ant-card-container">
        <Card>
          <CardContent>
            <Table<IdentityTableItem>
              title={"Used in Identities"}
              data={usedIdentities}
              isLoading={isLoading}
              tableId={"location-used-in-gvcs"}
              enableFilter
              columns={[
                NameDescriptionColumn(undefined, { shouldForceTargetBlank: () => true }),
                WorkloadGvcColumn() as any,
                TagsColumn(),
                CreatedColumn(),
                LastModifiedColumn(),
              ]}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
};
